import styled from 'styled-components';
import Card from 'components/common/Card';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContain = styled.div`
  flex: 1;
  max-width: 800px;
  margin-top: calc(88px + 40px);
`;

export const Title = styled(Card.Title)`
  font-size: 1.6em;
  margin-bottom: 0.2em;
  color: #0e476a !important;
`;

export const Text = styled.p`
  font-family: 'Roboto';
  line-height: 1.5em;
  color: #333;
  margin-top: 0.5em;
  font-weight: 300;
  margin-bottom: 1em;
`;

export const ContentContain = styled.div`
  margin: 16px;
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Button = styled.div`
  display: flex;
  flex: 1;
  color: #fff;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  padding: 0em 0.8em;
  line-height: 2.8em;
  justify-content: center;
  font-family: 'Roboto';
  background-color: ${(props) => props.theme.brandColor};

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;
